import { gql } from '@zenbusiness/application-commons-graphql';

export const PATCH_APPLICATION_INIT_DATA_MUTATION = gql`
  mutation patchApplicationInitData($input: PatchApplicationInitInput!) {
    patchApplicationInitData(input: $input) {
      status
    }
  }
`;

export const PROCESS_APPLICATION_DATA_MUTATION = gql`
  mutation processApplicationData($input: ProcessApplicationInput!) {
    processApplicationData(input: $input) {
      success
      message
      messageText
    }
  }
`;
